import { TCpdState } from '../../types/cpd/cpd';

const defaultState: TCpdState = {
  isAvailable: false,
};

export function cpdReducer(state: TCpdState = defaultState): TCpdState {
  return state;
}
